import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@chakra-ui/react';
import PrintPreview from './PrintPreview';
import { useReactToPrint } from 'react-to-print';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from '../../common/dataTable/DataTable';
import { getAllCertForGen } from '../../../api/certificates';
import { FETCH_CASH_APPLICATIONS_FOR_GEN } from '../../../store/actions/actionTypes';
import { LOGS_TABLE_DISPLAY_SIZE, BADGE_STATE_COLORS } from '../../../constants/dataTableConstants';

const CashGeneration = () => {
  const dispatch = useDispatch();
  const cashCertPrintRef = useRef();
  const [printData, setPrintData] = useState();
  const data = useSelector((state) => state.certificate.cashApplicationsGen);

  useEffect(() => {
    document.title = 'BTMA - Certificate Generation';
  }, []);

  const printCashIncentiveCertificate = useReactToPrint({
    documentTitle: `BTMA-Cash-Incentive-Certificate-${printData?.millName}-${printData?.certData?.certificateNum}`,
    content: () => cashCertPrintRef.current,
  });

  const columns = [
    { header: 'Certificate No', accessor: 'certificateNum' },
    { header: 'Date', accessor: 'createdAt', isDate: true },
    { header: 'Mill Name', accessor: 'millName' },
    {
      header: 'Status',
      accessor: 'status',
      isBadge: true,
      colorScheme: BADGE_STATE_COLORS,
      hoverInfo: ['remarks'],
    },
    {
      header: 'Action',
      accessor: 'status',
      isButton: true,
      actionScheme: [{ group: 'APPROVED', variant: 'print', action: 'PRINT' }],
    },
  ];

  const handlePagination = async ({ page, pageSize, searchKey, startDate, endDate }) => {
    dispatch({ type: FETCH_CASH_APPLICATIONS_FOR_GEN, payload: null });
    const params = {
      page,
      endDate,
      pageSize,
      searchKey,
      startDate,
      type: 'CASH',
    };
    const res = await getAllCertForGen({ type: 'production', params });
    if (res.data?.status === 200) {
      dispatch({ type: FETCH_CASH_APPLICATIONS_FOR_GEN, payload: res.data });
    } else {
      dispatch({ type: FETCH_CASH_APPLICATIONS_FOR_GEN, payload: { certificates: [] } });
    }
  };

  const handleSearch = async ({ searchKey, startDate, endDate }) => {
    dispatch({ type: FETCH_CASH_APPLICATIONS_FOR_GEN, payload: null });
    const params = {
      endDate,
      searchKey,
      startDate,
      type: 'CASH',
    };
    const res = await getAllCertForGen({ type: 'production', params });
    if (res.data?.status === 200) {
      dispatch({ type: FETCH_CASH_APPLICATIONS_FOR_GEN, payload: res.data });
    } else {
      dispatch({ type: FETCH_CASH_APPLICATIONS_FOR_GEN, payload: { certificates: [] } });
    }
  };

  const handlePrint = ({ rowObject }) => {
    const { millName, hoName, msAddress, cashAssitanceYarnExport, cashAssitanceFabricExport } =
      rowObject;
    setPrintData({
      millName,
      millAddress: hoName,
      factoryAddress: msAddress,
      certData: cashAssitanceYarnExport || cashAssitanceFabricExport,
      type: cashAssitanceYarnExport ? 'YARN' : cashAssitanceFabricExport ? 'FABRIC' : null,
    });
    setTimeout(() => {
      printCashIncentiveCertificate();
    }, 500);
  };

  return (
    <Box p={4}>
      <DataTable
        actions={{
          PRINT: handlePrint,
        }}
        topPanel
        keySearch
        dateRange
        isPaginated
        columns={columns}
        search={handleSearch}
        currentPage={data?.page}
        data={data?.certificates}
        paginate={handlePagination}
        entries={data?.totalEntries}
        currentPageSize={data?.pageSize}
        pageSizes={LOGS_TABLE_DISPLAY_SIZE}
        caption="Cash-Incentive Certificates"
      />
      <Box display="none">
        <PrintPreview ref={cashCertPrintRef} data={printData} />
      </Box>
    </Box>
  );
};

export default CashGeneration;
